import { FormToggle, FormLabel, FormSelect } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledNetworksHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3rem;
  gap: 2.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    height: 8.8rem;
    gap: 1.6rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
    height: 3.6rem;
    justify-content: space-between;
  }
`;

export const StyledNetworkHeaderNetworkInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  height: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    height: 100%;
  }
`;

export const StyledNetworkHeaderActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 0.8rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const StyledNetworkHeaderSaveActionButton = styled.div`
  width: 100%;

  & > button {
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 10.6rem;

    & > button {
      width: 100%;
    }
  }
`;

export const StyledNodesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCancelIconHeader = styled.div`
  position: absolute;
  right: 2.6rem;
  top: 2.6rem;
  display: flex;
  justify-content: flex-end;
  font-size: 2.4rem;
  cursor: pointer;

  & > button > svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const StyledElementHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2.4rem;
  margin-top: 2rem;
  font-size: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.light};
`;

export const StyledElementTitle = styled.div`
  margin-right: 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledConnectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const StyledFormControl = styled.div<{ $width?: string }>`
  width: ${({ $width = '100%' }) => $width};
  margin-right: 2.4rem;

  & > div > input:disabled {
    background-color: ${({ theme }) => theme.colors.grey[200]};
    color: ${({ theme }) => theme.colors.grey[600]};
  }
`;

export const StyledFormLabel = styled(FormLabel)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  display: flex;
  align-items: center;
`;

export const StyledNodeImageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledNodeImageData = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const StyledNodeImageHeader = styled.div`
  font-size: 1.6rem;
  line-height: 2rem;
  padding-top: 1.6rem;
  padding-left: 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledFormSelect = styled(FormSelect<false>)<{ $width?: string }>`
  width: ${({ $width = '30rem' }) => $width};
`;

export const StyledFormToggle = styled(FormToggle)`
  margin-right: 1rem;
`;

export const StyledLabel = styled.div`
  font-size: 1.6rem;
  line-height: 1.6rem;
  white-space: nowrap;
  padding: 1rem 0;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledSubnetLabel = styled.div`
  border-radius: 30px;
  background-color: ${({ theme }) => theme.colors.background.disabled};
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: 1.6rem;
  padding: 1rem 1.6rem;
  white-space: nowrap;
  width: fit-content;
`;

export const StyledFontAwesomePlusIcon = styled(FontAwesomeIcon)`
  font-weight: 900;
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.text.light};
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  font-weight: 900;
  font-size: 2rem;
`;

export const StyledDeleteIcon = styled(FontAwesomeIcon)<{ $color?: string }>`
  color: ${({ theme }) => theme.colors.text.lighter};
  width: 2rem;
  height: 2rem;
`;

export const StyledButtonWrapper = styled.div`
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 30rem;
    margin-left: 1.6rem;
    margin-right: 2.4rem;
  }
`;

export const StyledNodeImageButtonWrapper = styled.div`
  width: 100%;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.light};

  & > button {
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 19.1rem;
  }
`;

export const StyledSubmitButtonWrapper = styled.div<{ $mt?: string; $mb?: string }>`
  margin-top: ${({ $mt = 0 }) => $mt};
  margin-bottom: ${({ $mb = 0 }) => $mb};
  width: 100%;

  & > button {
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 18.7rem;
  }
`;
